import React from "react";
import styled from "styled-components";
import { H3, FlexRow, Icon } from "../";
import { formatDate } from "../";
import { Button } from "../Button";
export const DatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled
}) => {
  const getYear = value => formatDate(value, {
    year: "numeric"
  });

  const getMonth = value => formatDate(value, {
    month: "long"
  });

  return /*#__PURE__*/React.createElement(Container, {
    yCenter: true
  }, /*#__PURE__*/React.createElement(Nav, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Previous"
  })), /*#__PURE__*/React.createElement(IconButton, {
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Next"
  }))), /*#__PURE__*/React.createElement(Month, null, getMonth(date)), /*#__PURE__*/React.createElement(Year, null, getYear(date)));
};
const Container = styled(FlexRow)`
  height: 56px;
  padding: 12px;
  width: 100%;
  @media only screen and ${props => props.theme.media.small} {
    border-bottom: 1px solid ${props => props.theme.colors.disabledText};
    margin-bottom: 8px;
  }
`;
const Year = styled(H3)`
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  @media only screen and ${props => props.theme.media.small} {
    font-size: 17px;
    line-height: 22px;
  }
`;
const Month = styled(Year)`
  margin-left: 28px;
  margin-right: 8px;
`;
const IconButton = styled(Button)`
  cursor: pointer;
  color: #222222;
  background-color: transparent;
  border-radius: 50%;
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  svg {
    path {
      fill: ${props => props.theme.palette.gray.primary};
    }
  }
  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background-color: #f5f5f5;
    box-shadow: none;
    svg {
      path {
        fill: ${props => props.theme.colors.text};
      }
    }
  }
  &:disabled {
    background-color: transparent;
    padding: 0;
    svg {
      path {
        fill: ${props => props.theme.palette.gray.lighter};
      }
    }
  }
  & + & {
    margin-left: 16px;
  }
`;
const Nav = styled(FlexRow)``;